/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Lessons_GroupInputs */

const en_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessons`)
};

const es_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones`)
};

const de_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterricht`)
};

const zh_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程`)
};

const ar_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدروس`)
};

const fr_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçons`)
};

const vi_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài học`)
};

const sw_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masomo`)
};

const th_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียน`)
};

const bs_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcije`)
};

const ja_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスン`)
};

const ko_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨`)
};

const pt_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas`)
};

const it_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni`)
};

const sv_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektioner`)
};

const nl_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessen`)
};

const da_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektioner`)
};

const nb_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer`)
};

const fi_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunnit`)
};

const pl_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcje`)
};

const ru_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уроки`)
};

const tr_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dersler`)
};

const hi_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ`)
};

const id_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les`)
};

const ms_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelas`)
};

const cs_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekce`)
};

const el_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαθήματα`)
};

const he_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים`)
};

const af_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesse`)
};

const hu_nav_lessons_group = /** @type {(inputs: Nav_Lessons_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Órák`)
};

/**
* | output |
* | --- |
* | "Lessons" |
*
* @param {Nav_Lessons_GroupInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_lessons_group = /** @type {((inputs?: Nav_Lessons_GroupInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Lessons_GroupInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_lessons_group(inputs)
	if (locale === "de") return de_nav_lessons_group(inputs)
	if (locale === "zh") return zh_nav_lessons_group(inputs)
	if (locale === "ar") return ar_nav_lessons_group(inputs)
	if (locale === "fr") return fr_nav_lessons_group(inputs)
	if (locale === "vi") return vi_nav_lessons_group(inputs)
	if (locale === "sw") return sw_nav_lessons_group(inputs)
	if (locale === "th") return th_nav_lessons_group(inputs)
	if (locale === "bs") return bs_nav_lessons_group(inputs)
	if (locale === "ja") return ja_nav_lessons_group(inputs)
	if (locale === "ko") return ko_nav_lessons_group(inputs)
	if (locale === "pt") return pt_nav_lessons_group(inputs)
	if (locale === "it") return it_nav_lessons_group(inputs)
	if (locale === "sv") return sv_nav_lessons_group(inputs)
	if (locale === "nl") return nl_nav_lessons_group(inputs)
	if (locale === "da") return da_nav_lessons_group(inputs)
	if (locale === "nb") return nb_nav_lessons_group(inputs)
	if (locale === "fi") return fi_nav_lessons_group(inputs)
	if (locale === "pl") return pl_nav_lessons_group(inputs)
	if (locale === "ru") return ru_nav_lessons_group(inputs)
	if (locale === "tr") return tr_nav_lessons_group(inputs)
	if (locale === "hi") return hi_nav_lessons_group(inputs)
	if (locale === "id") return id_nav_lessons_group(inputs)
	if (locale === "ms") return ms_nav_lessons_group(inputs)
	if (locale === "cs") return cs_nav_lessons_group(inputs)
	if (locale === "el") return el_nav_lessons_group(inputs)
	if (locale === "he") return he_nav_lessons_group(inputs)
	if (locale === "af") return af_nav_lessons_group(inputs)
	if (locale === "hu") return hu_nav_lessons_group(inputs)
	return en_nav_lessons_group(inputs)
});